// All content for Vita da Host landing
export const LOGO_URL = "https://customer-assets.emergentagent.com/job_429979d6-d25e-4b1c-9d81-45205e323c1e/artifacts/12homqre_Logo%20png%20trasp%20vita%20da%20host.png";

export const HOSTCLUB_URL = "/hostclub";

export const SERVICES = [
  {
    key: "calcolatore-guadagni",
    title: "Calcola guadagni",
    subtitle: "Airbnb · Booking · Diretto",
    description:
      "Quanto guadagni davvero come host? Confronta in tempo reale Airbnb, Booking e prenotazione diretta. Commissioni, IVA, cedolare: in un colpo d'occhio.",
    image:
      "https://customer-assets.emergentagent.com/job_vita-portal/artifacts/9nsyplgr_calcolatore%20prezzi.png",
    url: "/calcolatoreguadagniaffittibrevi",
    accent: "#ff3b3b",
    highlight: true,
  },
  {
    key: "lt-it",
    title: "locazione-turistica.it",
    subtitle: "locazione-turistica.it",
    description:
      "La rivoluzione per la gestione degli HOST PRIVATI italiani. È incredibile.",
    image:
      "https://customer-assets.emergentagent.com/job_vita-portal/artifacts/v0oi7gxq_logo%20locazione%20t.png",
    imageBg: "#ffffff",
    url: "https://contratti.vitadahost.it/",
    accent: "#0d9488",
  },
  {
    key: "hostland",
    title: "Hostland",
    subtitle: "Il tuo sito, facile facile",
    description:
      "È un guestbook digitale che ti permetterà di fare impazzire i tuoi ospiti oltre che liberarti dalle OTA.",
    image:
      "https://customer-assets.emergentagent.com/job_vita-portal/artifacts/m21mot33_HOSTLAND%20LOGO%20NUOVO.png",
    url: "https://hostland.vitadahost.it/",
    accent: "#ff4fcf",
  },
  {
    key: "corso",
    title: "Corso Affiancamento LIVE",
    subtitle: "AvviaBnb",
    description:
      "Diventa Host o Property Manager con l'unico percorso LIVE, senza video registrati. Ti seguiamo passo passo dalla teoria alla pratica.",
    image:
      "https://customer-assets.emergentagent.com/job_429979d6-d25e-4b1c-9d81-45205e323c1e/artifacts/7hmjf3q6_corso%20affiancmaneto.png",
    url: "/servizi/avviabnb",
    accent: "#4fc3ff",
  },
  {
    key: "hostlab",
    title: "HostLab",
    subtitle: "10€ · 1 ora · 100% Formazione",
    description:
      "La nostra formazione: vera, con professionisti e democratica. Dimentica i fuffaguru — qui si fa sul serio.",
    image:
      "https://customer-assets.emergentagent.com/job_429979d6-d25e-4b1c-9d81-45205e323c1e/artifacts/ms1xlg4l_hostlab%20logo%20nuovo%201.png",
    url: "/servizi/hostlab",
    accent: "#b47dff",
  },
  {
    key: "hostclub",
    title: "HostClub",
    subtitle: "Uno spazio premium tutto incluso",
    description:
      "Il club per chi ci supporta: sconti sulle consulenze, sui materiali, risorse gratuite e supporto immediato.",
    image:
      "https://customer-assets.emergentagent.com/job_429979d6-d25e-4b1c-9d81-45205e323c1e/artifacts/qz4yavji_HOSTCLUB%20QUADRATO.png",
    url: HOSTCLUB_URL,
    accent: "#f7d14f",
  },
  {
    key: "faqbnb",
    title: "FaqBnb",
    subtitle: "Il manuale aggiornato 2026",
    description:
      "Il manuale che tutti gli host dovrebbero avere: tutto quello che volete sapere sul mondo degli affitti brevi (che non avete mai osato chiedere).",
    image:
      "https://customer-assets.emergentagent.com/job_vita-portal/artifacts/zvq8bvmm_NUOVA%20ICONA%20FAQBNB.png",
    url: "/negozio?product=faqbnb",
    accent: "#ff5c6c",
  },
  {
    key: "hostmarket",
    title: "HostMarket",
    subtitle: "La piazza digitale",
    description:
      "La piazza digitale per trovare professionisti e proporsi alla rete. Lo spazio perfetto per pubblicizzare la tua azienda o professione.",
    image:
      "https://customer-assets.emergentagent.com/job_vita-portal/artifacts/lcf6dk52_hostmarket%20nuovooo.png",
    url: "/servizi/hostmarket",
    accent: "#ff2eb8",
  },
  {
    key: "getyourguide",
    title: "GetYourGuide",
    subtitle: "Le esperienze pronte da stampare",
    description:
      "Scarica i nostri PDF già pronti per fornire esperienze ai tuoi ospiti in un attimo. Partner ufficiale Vita da Host.",
    image:
      "https://customer-assets.emergentagent.com/job_vita-portal/artifacts/y34f8bgx_Screenshot%202026-04-22%20alle%2001.51.51.png",
    url: "/servizi/getyourguide",
    accent: "#ff7a1f",
  },
  {
    key: "host-furious",
    title: "Host & Furious",
    subtitle: "Il podcast ufficiale di Vita da Host",
    description:
      "Ascolta il nostro podcast con le ultime novità del mondo degli affitti brevi. Ascolta e segui dove vuoi.",
    image:
      "https://customer-assets.emergentagent.com/job_vita-portal/artifacts/vh885f34_h%26furiopus.png",
    url: "https://open.spotify.com/show/0Z0ZbTupFc67dxRVUEH5so?si=292f3877977544a5",
    accent: "#ff3b3b",
  },
  {
    key: "cinfacile",
    title: "CIN Facile",
    subtitle: "Le pratiche burocratiche al posto tuo",
    description:
      "Alle noiose pratiche burocratiche ci pensiamo noi, in tutta Italia. Chiedi un consulto senza impegno.",
    image:
      "https://customer-assets.emergentagent.com/job_vita-portal/artifacts/4oto69gp_cinfacilenuovo.png",
    url: "/servizi/cin-facile",
    accent: "#1fb8b0",
  },
  {
    key: "qr-code",
    title: "QR Code Generator",
    subtitle: "Gratis · alta risoluzione",
    description:
      "Crea QR Code per link e WiFi fino a 4096×4096 px. Senza registrazione, perfetti per camere, welcome book, recensioni e tassa di soggiorno.",
    image:
      "https://customer-assets.emergentagent.com/job_vita-portal/artifacts/7rp3h47b_cody%20app.png",
    url: "/qrcodegratis",
    accent: "#1ca7ff",
  },
];

export const APPS = [
  {
    key: "vdh",
    name: "Vita da Host",
    tagline: "Il portale italiano per host, sempre in tasca.",
    icon: "https://customer-assets.emergentagent.com/job_vita-portal/artifacts/gs2v6oy2_logo%20per%20servizi.png",
    ios: "https://apps.apple.com/it/app/vita-da-host/id6760694341",
    android: "https://play.google.com/store/apps/details?id=com.wnapp.id1778937032200",
  },
  {
    key: "faqbnb",
    name: "FaqBnb",
    tagline: "Tutte le risposte che cerchi sugli affitti brevi, in un tap.",
    icon: "https://customer-assets.emergentagent.com/job_vita-portal/artifacts/hq5yijry_faqbnb%20icona.png",
    ios: "https://apps.apple.com/it/app/faqbnb/id6760727873",
    android: null, // Android version still in development
  },
];

// FREE 15-min consultations (shown on home + consulenze page)
export const FREE_CALLS = [
  {
    key: "sergio",
    name: "Sergio Battelli",
    role: "Fondatore Vita da Host",
    photo: "https://customer-assets-m6fa6gv7.emergentagent.net/job_vita-portal/artifacts/743b45pd_foto%20sergio%20sito.png",
    duration: "15 min",
    color: "#ff4fcf",
    intro:
      "Una breve call conoscitiva dove potrai farmi tutte le domande che desideri sulla tua struttura ricettiva.",
    topics: [
      "Come avviare una nuova struttura",
      "Consigli e dubbi su novità e normative",
      "Conoscerci e pianificare una collaborazione",
      "Consulenza generica sugli affitti brevi",
    ],
    bookUrl: "https://vitadahost.short.gy/Call15Min",
  },
  {
    key: "francesca",
    name: "Francesca Spinazzola",
    role: "HomeStager & Immagine · Responsabile HostLAB",
    photo: "https://customer-assets.emergentagent.com/job_vita-portal/artifacts/mjdiuog0_WhatsApp%20Image%202026-05-10%20at%2010.03.22.jpeg",
    duration: "15 min",
    color: "#EA580C",
    intro:
      "Una breve call conoscitiva dove potrai farmi tutte le domande sulla presentazione della tua struttura.",
    topics: [
      "Come migliorare l'aspetto degli ambienti",
      "Quali piccoli interventi aumentano il valore percepito",
      "Cosa funziona e cosa evitare nelle strutture turistiche",
      "Dubbi su allestimento, dettagli, atmosfera e fotografia",
    ],
    bookUrl: "https://prodotti.francescaspinazzola.it/consulenze",
  },
  {
    key: "lorenzo",
    name: "Lorenzo Stagno",
    role: "Commercialista esperto affitti brevi",
    photo:
      "https://customer-assets.emergentagent.com/job_vita-portal/artifacts/6an5twxp_1641381096519-1.jpg",
    duration: "15 min",
    color: "#4fc3ff",
    intro:
      "Una breve call gratuita per risolvere i tuoi dubbi fiscali sugli affitti brevi: Partita IVA, tasse, regimi.",
    topics: [
      "Quando serve la Partita IVA",
      "Cedolare secca e regime fiscale ottimale",
      "Tassazione 2026 per affitti brevi",
      "Dichiarazioni, F24 e adempimenti",
    ],
    bookUrl: "https://tidycal.com/bnbtaxgenius/consulenza-per-affitti-brevi",
  },
];

// PAID exclusive calls - shown on /consulenze page
// Prices in EUR. hostclubPrice = discounted price for HostClub members.
export const EXCLUSIVE_CALLS = [
  {
    key: "airbnb-annuncio",
    title: "Creiamo insieme l'annuncio su Airbnb",
    subtitle: "Ottimizzazione annuncio + SEO Airbnb",
    duration: "2 ore",
    price: 70,
    hostclubPrice: 40,
    accent: "#FF5A5F",
    brand: "airbnb",
    brandLogo: "https://customer-assets.emergentagent.com/job_vita-portal/artifacts/yz20b08e_airbnb.jpg",
    gradient: "linear-gradient(135deg, rgba(255,90,95,0.22) 0%, rgba(229,30,37,0.12) 100%)",
    borderColor: "rgba(255,90,95,0.50)",
    description:
      "Costruiamo da zero (o revisioniamo) il tuo annuncio su Airbnb: titolo, descrizione, foto, tag, pricing. In circa 2 ore esci con l'annuncio finito: più visualizzazioni e più prenotazioni.",
    bookUrl: "https://calendly.com/vitadahost/creiamo-insieme-l-annuncio-su-airbnb",
  },
  {
    key: "booking-annuncio",
    title: "Creiamo il tuo annuncio su Booking",
    subtitle: "Extranet, tariffe e promozioni",
    duration: "2 ore",
    price: 70,
    hostclubPrice: 40,
    accent: "#00AEEF",
    brand: "booking",
    brandLogo: "https://customer-assets.emergentagent.com/job_vita-portal/artifacts/sk3yzxic_booking-com-logo-png_seeklogo-474475.png",
    gradient: "linear-gradient(135deg, rgba(0,174,239,0.24) 0%, rgba(64,196,255,0.12) 100%)",
    borderColor: "rgba(0,174,239,0.55)",
    description:
      "Costruiamo l'annuncio su Booking.com passo passo: Extranet, gestione tariffe, genius program, politiche di cancellazione e coerenza dei prezzi tra i canali. In circa 2 ore esci con l'annuncio finito.",
    bookUrl: "https://calendly.com/vitadahost/creiamo-insieme-il-tuo-annuncio-su-booking-com",
  },
  {
    key: "vrbo-annuncio",
    title: "Creiamo insieme l'annuncio su VRBO",
    subtitle: "Expedia Group · audience nordamericana",
    duration: "2 ore",
    price: 70,
    hostclubPrice: 40,
    accent: "#ffffff",
    brand: "vrbo",
    brandLogo: "https://customer-assets.emergentagent.com/job_vita-portal/artifacts/z7y4kddy_unnamed-4.png",
    gradient: "linear-gradient(135deg, rgba(255,255,255,0.20) 0%, rgba(255,255,255,0.06) 100%)",
    borderColor: "rgba(255,255,255,0.45)",
    description:
      "Apriamo e ottimizziamo il tuo annuncio su VRBO (gruppo Expedia): traduzioni, foto, tariffe, sincronizzazione con il calendario, accesso al mercato USA/UK.",
    bookUrl: "https://calendly.com/vitadahost/creiamo-insieme-l-annuncio-vrbo",
  },
  {
    key: "meeting-1h",
    title: "1 ora di meeting e approfondimenti",
    subtitle: "La call completa su misura con Sergio",
    duration: "1 ora",
    price: 40,
    hostclubPrice: 20,
    accent: "#EA580C",
    brand: "lightbulb",
    brandLogo: "https://customer-assets.emergentagent.com/job_vita-portal/artifacts/ctdt9lm8_Screenshot%202026-06-22%20alle%2021.10.43.png",
    gradient: "linear-gradient(135deg, rgba(234,88,12,0.22) 0%, rgba(234,179,8,0.12) 100%)",
    borderColor: "rgba(234,88,12,0.55)",
    description:
      "Un'ora intera con Sergio Battelli per analizzare a fondo il tuo progetto: aspetti fiscali, operativi, tecnologici, di marketing. Risposte chiare a tutti i tuoi dubbi.",
    bookUrl: "https://calendly.com/vitadahost/1-ora-di-meeting-e-approfondimenti",
  },
  {
    key: "prezzo-dinamico",
    title: "Impara tutto sul prezzo dinamico",
    subtitle: "Cos'è, quali strumenti e perché serve",
    duration: "1 ora",
    price: 40,
    hostclubPrice: 20,
    accent: "#4ade80",
    brand: "euro",
    iconType: "euro",
    gradient: "linear-gradient(135deg, rgba(74,222,128,0.20) 0%, rgba(16,185,129,0.10) 100%)",
    borderColor: "rgba(74,222,128,0.50)",
    description:
      "Un'ora dedicata al pricing dinamico: cos'è davvero, quali strumenti usare (PriceLabs, Wheelhouse, Beyond…), come impostarli e perché il prezzo dinamico fa la differenza sui tuoi guadagni.",
    bookUrl: "https://calendly.com/vitadahost/prezzo-dinamico",
  },
  {
    key: "self-checkin",
    title: "Crea il tuo sistema di Self Check-in",
    subtitle: "Smart lock, videoverifica, flusso conforme",
    duration: "1 ora",
    price: 40,
    hostclubPrice: 20,
    accent: "#EA580C",
    brand: "digital-key",
    brandLogo: "https://customer-assets.emergentagent.com/job_vita-portal/artifacts/6z8ft8as_7318768.png",
    gradient: "linear-gradient(135deg, rgba(38,38,40,0.90) 0%, rgba(15,15,17,0.92) 100%)",
    borderColor: "rgba(250,204,21,0.35)",
    description:
      "Progettiamo insieme il self check-in conforme alla sentenza del Consiglio di Stato: verifica identità in tempo reale, smart lock, keybox e automazioni.",
    bookUrl: "https://calendly.com/vitadahost/crea-il-tuo-sistema-di-self-check-in",
  },
];

// Combo package "Spacca Tutto"
export const COMBO_PACKAGE = {
  title: "Spacca Tutto",
  subtitle: "Il pacchetto combo Sergio + Francesca",
  tagline: "Strategia annuncio + presentazione visiva in un unico blocco.",
  description:
    "Un pacchetto pensato per migliorare sia la strategia dell'annuncio sia la presentazione visiva della struttura. Due professionisti, una sola soluzione completa.",
  sergioItems: [
    "Analisi dell'annuncio sui portali",
    "Suggerimenti su titolo, descrizione e struttura",
    "Indicazioni per migliorare visibilità e conversioni",
  ],
  francescaItems: [
    "Revisione delle foto presenti nell'annuncio",
    "Suggerimenti di styling e miglioramento visivo",
    "Indicazioni su foto e video più efficaci",
  ],
  bookUrl: "https://calendly.com/vitadahost/superottimizzazione",
  price: "90€",
};

// 10 domande generate da FAQBNB 2026.
export const QUIZ = [
  {
    id: 1,
    difficulty: "Facile",
    q: "Qual è il primo obbligo burocratico per ogni ospite che soggiorna più di una notte?",
    options: [
      { text: "Inviare i dati all'ISTAT", v: 0 },
      { text: "Registrarlo su Alloggiati Web della Polizia di Stato", v: 2 },
      { text: "Chiedere solo copia del passaporto", v: 0 },
    ],
  },
  {
    id: 2,
    difficulty: "Media",
    q: "Cosa distingue la Locazione Turistica da una Struttura Ricettiva (B&B, Affittacamere)?",
    options: [
      { text: "La locazione turistica richiede sempre Partita IVA", v: 0 },
      { text: "La locazione turistica non prevede servizi accessori (es. colazione, pulizie giornaliere)", v: 2 },
      { text: "Le strutture ricettive possono affittare solo camere singole", v: 0 },
    ],
  },
  {
    id: 3,
    difficulty: "Facile",
    q: "Se un ospite ti chiede una ricevuta per il pagamento, cosa devi rilasciare?",
    options: [
      { text: "Una fattura con IVA, anche se sono un privato", v: 0 },
      { text: "Una ricevuta non fiscale con l'importo pagato", v: 2 },
      { text: "Niente, non è richiesto", v: 0 },
    ],
  },
  {
    id: 4,
    difficulty: "Difficile",
    q: "Sentenza Consiglio di Stato sul self check-in: quale modalità è considerata conforme?",
    options: [
      { text: "Documento via email + codice keybox, senza interazione", v: 0 },
      { text: "Foto documento + selfie inviati prima dell'arrivo", v: 1 },
      { text: "Videocollegamento che verifica l'identità in tempo reale", v: 2 },
    ],
  },
  {
    id: 5,
    difficulty: "Media",
    q: "Qual è il vantaggio principale di un Channel Manager?",
    options: [
      { text: "Permette sconti più alti agli ospiti", v: 0 },
      { text: "Centralizza prezzi e calendari evitando overbooking", v: 2 },
      { text: "Migliora il posizionamento solo su Airbnb", v: 0 },
    ],
  },
  {
    id: 6,
    difficulty: "Facile",
    q: "Su quale OTA esiste una copertura simile a un 'kasko dell'host' inclusa gratuitamente?",
    options: [
      { text: "Booking.com", v: 0 },
      { text: "Airbnb (AirCover)", v: 2 },
      { text: "Expedia", v: 0 },
    ],
  },
  {
    id: 7,
    difficulty: "Media",
    q: "Perché è fondamentale verificare la destinazione d'uso dell'immobile?",
    options: [
      { text: "Indica il numero di stanze", v: 0 },
      { text: "Deve essere residenziale per affittare a scopo turistico", v: 2 },
      { text: "Serve solo per affitti di lunga durata", v: 0 },
    ],
  },
  {
    id: 8,
    difficulty: "Difficile",
    q: "Come gestiscono Airbnb e Booking la riscossione della tassa di soggiorno?",
    options: [
      { text: "Airbnb la riscuote sempre, Booking mai", v: 0 },
      { text: "Booking la riscuote, Airbnb mai", v: 0 },
      { text: "Airbnb può accordarsi con alcuni comuni, Booking la lascia sempre all'host", v: 2 },
    ],
  },
  {
    id: 9,
    difficulty: "Media",
    q: "Perché è consigliato variare leggermente i prezzi nel tempo (pricing dinamico)?",
    options: [
      { text: "Per confondere la concorrenza", v: 0 },
      { text: "Gli algoritmi premiano gli annunci attivi che seguono la domanda", v: 2 },
      { text: "Per nascondere la disponibilità", v: 0 },
    ],
  },
  {
    id: 10,
    difficulty: "Facile",
    q: "Qual è il vantaggio principale di un professionista di Homestaging?",
    options: [
      { text: "Ristruttura l'intero immobile a basso costo", v: 0 },
      { text: "Valorizza gli spazi per renderli più appetibili online", v: 2 },
      { text: "Si occupa della burocrazia", v: 0 },
    ],
  },
];

export const SOCIALS = [
  { name: "Instagram", url: "https://www.instagram.com/vita_da_host_/", icon: "instagram" },
  { name: "TikTok", url: "https://www.tiktok.com/@vita.da.host", icon: "tiktok" },
  { name: "Facebook", url: "https://www.facebook.com/VitadaHostUfficiale/", icon: "facebook" },
  { name: "Threads", url: "https://www.threads.com/@vita_da_host_", icon: "threads" },
  { name: "YouTube", url: "https://youtube.com/@vitadahostchannel", icon: "youtube" },
  { name: "LinkedIn", url: "https://www.linkedin.com/in/sergio-battelli-vitadahost/", icon: "linkedin" },
];
